import { request } from '../request'
import type { ProxyUser } from './types'

export const login = (data: { username: string; password: string }) =>
  request<string>('/api/portal/auth/login', { method: 'POST', body: data })

export const register = (data: { username: string; password: string; accessIp: string }) =>
  request<ProxyUser>('/api/portal/auth/register', { method: 'POST', body: data })

export const logout = () => request<void>('/api/portal/auth/logout', { method: 'POST' })

export const me = () => request<ProxyUser>('/api/portal/auth/me')

export const changePassword = (data: { oldPassword: string; newPassword: string }) =>
  request<void>('/api/portal/auth/password', { method: 'POST', body: data })
